import { useQuery } from '@tanstack/react-query';
import { auditApi, type ListAuditParams } from '@/api/audit.api';

export const auditKeys = {
  all: ['audit'] as const,
  list: (params: ListAuditParams) => [...auditKeys.all, params] as const,
};

export function useAudit(params: ListAuditParams = {}) {
  return useQuery({
    queryKey: auditKeys.list(params),
    queryFn: () => auditApi.list(params),
  });
}
